<template>
  <div>
    <wc-dialog
      title='Log details'
      :fullscreen='$vuetify.breakpoint.xs ? true : false'
      :showDialog='showDialog'
      :icon='$store.state.icons.snowTracker.icon'
      :iconColor='$store.state.icons.snowTracker.iconColor'
      @cancel="$emit('cancel')"
      @save='save'
      width='450'
    >
      What's the weather for this day?<br>
        <v-btn depressed @click="setWeather('snow')" :color="logCopy.is_snowing ? snowIcon.color : 'light'" class='mr-3 mb-3'>
          <v-icon left :color="logCopy.is_snowing ? 'white' : snowIcon.color">{{ snowIcon.icon }}</v-icon>
          <span :class="logCopy.is_snowing ? 'white--text' : ''">{{ snowIcon.text }}</span>
        </v-btn>
        <v-btn depressed @click="setWeather('sun')" :color="logCopy.is_sunny ? sunIcon.color : 'light'" class='mr-3 mb-3'>
          <v-icon left :color="logCopy.is_sunny ? 'white' : sunIcon.color">{{ sunIcon.icon }}</v-icon>
          <span :class="logCopy.is_sunny ? 'white--text' : ''">{{ sunIcon.text }}</span>
        </v-btn>
        <v-btn depressed @click="setWeather('cloud')" :color="logCopy.is_cloudy ? cloudIcon.color : 'light'" class='mr-3 mb-3'>
          <v-icon left :color="logCopy.is_cloudy ? 'white' : cloudIcon.color">{{ cloudIcon.icon }}</v-icon>
          <span :class="logCopy.is_cloudy ? 'white--text' : ''">{{ cloudIcon.text }}</span>
        </v-btn>
      <br>
      <br>
      <br>
      How much snow has fallen?<br>
      <v-btn depressed @click='logCopy.snow_amount = 0' :color="logCopy.snow_amount === 0 ? 'info' : 'light'" class='mr-3 mb-3'>
        <span :class="logCopy.snow_amount === 0 ? 'white--text' : 'grey--text'">None</span>
      </v-btn>
      <v-btn depressed @click='logCopy.snow_amount = 2' :color="logCopy.snow_amount === 2 ? 'info' : 'light'" class='mr-3 mb-3'>
        <span :class="logCopy.snow_amount === 2 ? 'white--text' : 'grey--text'">0-2cm</span>
      </v-btn>
      <v-btn depressed @click='logCopy.snow_amount = 4' :color="logCopy.snow_amount === 4 ? 'info' : 'light'" class='mr-3 mb-3'>
        <span :class="logCopy.snow_amount === 4 ? 'white--text' : 'grey--text'">2-4cm</span>
      </v-btn>
      <v-btn depressed @click='logCopy.snow_amount = 6' :color="logCopy.snow_amount === 6 ? 'info' : 'light'" class='mr-3 mb-3'>
        <span :class="logCopy.snow_amount === 6 ? 'white--text' : 'grey--text'">6cm+</span>
      </v-btn>
      <br>
      <br>
      <v-alert v-if='logCopy.routes_generated' type='warning' dense border='bottom'>Cannot edit next section - routes have been generated</v-alert>
      <br>
      Should snow clearing crew(s) go out today? <br>
      <v-btn :disabled='logCopy.routes_generated' depressed :color="logCopy.send_crews ? 'success' : 'light'" @click='logCopy.send_crews = true' class='mr-3'>
        <v-icon :color="logCopy.send_crews ? 'white' : 'grey'" left>mdi-check</v-icon>
        <span :class="logCopy.send_crews ? 'white--text' : 'grey--text'">Yes</span>
      </v-btn>
      <v-btn :disabled='logCopy.routes_generated' depressed :color="logCopy.send_crews ? 'light' : 'error'" @click='logCopy.send_crews = false' class='mr-3'>
        <v-icon :color="logCopy.send_crews ? 'grey' : 'white'" left>mdi-close</v-icon>
        <span :class="logCopy.send_crews ? 'grey--text' : 'white--text'">No</span>
      </v-btn>
      <br>
      <br>
      <br>
      What should the crews bring?<br>
        <v-btn
          depressed
          :disabled='logCopy.routes_generated'
          :color="logCopy.bring_shovels ? 'info': ''"
          class='mb-3 mr-3'
          @click='logCopy.bring_shovels = !logCopy.bring_shovels'
        >
          Shovels
        </v-btn>
        <v-btn
          depressed
          :disabled='logCopy.routes_generated'
          :color="logCopy.bring_leaf_blowers ? 'info': ''"
          class='mb-3 mr-3'
          @click='logCopy.bring_leaf_blowers = !logCopy.bring_leaf_blowers'
        >
          Leaf blowers
        </v-btn>
        <v-btn
          depressed
          :disabled='logCopy.routes_generated'
          :color="logCopy.bring_snow_blowers ? 'info': ''"
          class='mb-3 mr-3'
          @click='logCopy.bring_snow_blowers = !logCopy.bring_snow_blowers'
        >
          Snow blowers
        </v-btn>
        <br>
        <br>
        <v-btn
          depressed
          :disabled='logCopy.routes_generated'
          :color="logCopy.bring_ice_scrapers ? 'info': ''"
          class='mb-3 mr-3'
          @click='logCopy.bring_ice_scrapers = !logCopy.bring_ice_scrapers'
        >
          Ice scrapers
        </v-btn>
        <v-btn
          depressed
          :disabled='logCopy.routes_generated'
          :color="logCopy.bring_ice_melt ? 'info': ''"
          class='mb-3 mr-3'
          @click='logCopy.bring_ice_melt = !logCopy.bring_ice_melt'
        >
          Rock Chip
        </v-btn>
    </wc-dialog>
  </div>
</template>

<script>
// import equipmentAPI from '@/modules/assets/api/equipment'
import snowTrackerServices from '../services/snowTracker'
import snowTrackerAPI from '../api/snowTracker'
import _ from 'lodash'

export default {
  name: 'log-dialog',
  props: {
    showDialog: {
      required: true
    },
    log: {
      required: true
    },
    date: {
      required: false
    }
  },
  data: () => ({
    isLoading: false,
    isLoadingEquipment: true,
    isFormValid: false,
    equipment: [],
    logCopy: {
      date: '',
      is_sunny: true,
      is_cloudy: false,
      is_snowing: false,
      snow_amount: 0,
      send_crews: false,
      bring_shovels: false,
      bring_leaf_blowers: false,
      bring_snow_blowers: false,
      bring_ice_scrapers: false,
      bring_ice_melt: false,
      routes_generated: false
    }
  }),
  computed: {
    sunIcon () {
      return snowTrackerServices.getSunIcon()
    },
    snowIcon () {
      return snowTrackerServices.getSnowIcon()
    },
    cloudIcon () {
      return snowTrackerServices.getCloudIcon()
    },
    division () {
      return this.$store.state.misc.divisions.find(d => d.division_type === 'S')
    }
  },
  watch: {
    showDialog () {
      this.resetLogCopy()
      if (this.log) {
        this.logCopy = _.cloneDeep(this.log)
      }
    }
  },
  methods: {
    resetLogCopy () {
      this.logCopy.date = this.date
      this.logCopy.is_sunny = false
      this.logCopy.is_cloudy = false
      this.logCopy.is_snowing = true
      this.logCopy.snow_amount = 2
      this.logCopy.send_crews = false
      this.logCopy.bring_shovels = false
      this.logCopy.bring_leaf_blowers = false
      this.logCopy.bring_snow_blowers = false
      this.logCopy.bring_ice_scrapers = false
      this.logCopy.bring_ice_melt = false
      this.logCopy.routes_generated = false
    },
    setWeather(val) {
      this.logCopy.is_snowing = val === 'snow' ? true : false
      this.logCopy.is_sunny = val === 'sun' ? true : false
      this.logCopy.is_cloudy = val === 'cloud' ? true : false
    },
    async save () {
      let tmp = null
      if (this.log) {
        // This is an update to an existing record
        tmp = await snowTrackerAPI.updateSnowTrackerLog(this.logCopy)
      } else{
        tmp = await snowTrackerAPI.createSnowTrackerLog(this.logCopy)
      }
      this.$emit('save', tmp)
    }
  }
}
</script>
